const axios = require('axios');

module.exports = () => {
  const ads = document.querySelectorAll('.ad a');
  ads.forEach(ad => {

    ad.addEventListener('click', e => {
      const id = ad.id;
      axios.get(`//i2icenter.org/wp-content/themes/i2icenter/log-click.php?id=${id}`)        
        .catch(error => console.error(error));

      });


      const containerHeight = parseInt(window.getComputedStyle(ad.children[0]).height);

      const checkPosition = () => {
        if (containerHeight) {

          const shownAt = (window.scrollY + window.innerHeight) - containerHeight / 2;
          const adBottom = ad.offsetTop + containerHeight;
          const isHalfShown = shownAt > ad.offsetTop;
          const isNotScrolledPast = window.scrollY < adBottom - containerHeight;

          if (isHalfShown && isNotScrolledPast) {
            clearInterval(checkImpression);
            axios.get(`//i2icenter.org/wp-content/themes/i2icenter/log-impression.php?id=${ad.id}`)
              .catch(error => console.error(error));
          }

        }
      }

      const checkImpression = setInterval(checkPosition, 250);

  });

}
